module.exports = __webpack_public_path__ + "static/media/timeline6.ed04d031.png";